import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage = () => (
  <main className="not-found-page" data-testid="not-found-page">
    <p className="not-found-label">— 404</p>
    <h1 className="not-found-title">Page not found.</h1>
    <p className="not-found-copy">
      The page you are looking for does not exist or has been moved.
    </p>
    <nav className="not-found-nav" aria-label="Back to site">
      <Link to="/" className="not-found-link">
        ← Home
      </Link>
      <Link to="/work" className="not-found-link">
        View work ↗
      </Link>
    </nav>
  </main>
);

export default NotFoundPage;
